export default __webpack_public_path__ + "static/media/bannersweb_mespatrio_coche_330x330.ea93d4b3.webp";